import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IAnamneseChoosePopupModal } from 'src/app/models/anamnese-choose-popup-modal.model';
import { openCloseAnamneseChoosePopupModal, setAnamneseChoosePopupType, setAnamneseExcludeProcessStatus } from 'src/app/reducers/anamnese-choose-popup.reducer';
import { AnamneseService } from 'src/app/services/anamnese.service';

@Component({
  selector: 'app-anamnese-choose-popup',
  templateUrl: './anamnese-choose-popup.component.html',
  styleUrls: ['./anamnese-choose-popup.component.sass']
})
export class AnamneseChoosePopupComponent {

  faTimes = faTimes;
  loading = false;

  @Input({ required: true }) ongoingAnamneseId: string = '';
  @Input({ required: true }) patientId: any = '';
  @Input({ required: true }) patientForm: any = {};

  anamneseChoosePopupType: {
    [key: string]: any
  } = {};
  anamneseExcludeProcessStatus = false;
  anamneseChoosePopupModal: Observable<IAnamneseChoosePopupModal>;

  constructor(
    private store: Store<{ anamneseChoosePopupModal: IAnamneseChoosePopupModal }>,
    private router: Router,
    private anamneseService: AnamneseService,
  ) {
    this.anamneseChoosePopupModal = this.store.select('anamneseChoosePopupModal');
    this.anamneseChoosePopupModal.subscribe((data) => {
      this.anamneseChoosePopupType = data.anamneseChoosePopupType;
      this.anamneseExcludeProcessStatus = data.isExcluded;
    });
  }

  openClose() {
    if (!this.loading) {
      this.store.dispatch(openCloseAnamneseChoosePopupModal());
    }
  }

  onConfirmAnamneseChoosePopup(reuseAnamnese: boolean) {
    if (!this.loading) {
      this.openClose();
      this.router.navigate(['main', 'anamneses', 'create'], {
        queryParams: {
          patientId: this.patientId,
          patientName: this.patientForm.controls['name'].value?.trim(),
          patientEmail: this.patientForm.controls['email'].value,
          patientPhoneNumber: this.patientForm.controls['phone'].value,
          reuseInfo: reuseAnamnese
        }
      });
    }
  }

  onClickReopenAnamneseOngoingChoosePopup() {
    if (!this.loading) {
      this.openClose();
      this.router.navigate(['main', 'anamneses', this.ongoingAnamneseId, 'view'], {
        queryParams: {
          patientId: this.patientId,
          patientName: this.patientForm.controls['name'].value?.trim(),
          patientEmail: this.patientForm.controls['email'].value,
          patientPhoneNumber: this.patientForm.controls['phone'].value
        }
      });
    }
  }

  onClickDeleteAnamneseOngoingChoosePopup() {
    if (!this.loading) {
      this.loading = true;
      this.anamneseService.deleteAnamnese(this.ongoingAnamneseId).subscribe(() => {
        this.store.dispatch(setAnamneseExcludeProcessStatus(true));
        this.loading = false;
        if (this.anamneseChoosePopupType['has_previous_anamnese']) {
          this.store.dispatch(setAnamneseChoosePopupType({ ...this.anamneseChoosePopupType, has_unanswered_anamnese: false }));
        }
        else {
          this.onConfirmAnamneseChoosePopup(false);
        }
      });
    }
  }
}
